export default "__VITE_ASSET__CkVlDsGK__"